module.exports = __webpack_public_path__ + "img/end-bg-1.595873fe.svg";